export default {
  oAuth2TokenCookieName: 'OAuth2Token',
  personalizationApi: {
    space: 'a4nvg3fdk34l',
    accessToken: '22b11df22df515fc025eb9c9ed204d5db373d3f2f811f7ea3c0455e6ec52202e',
    host: window.location.hostname,
    basePath: 'personalization-api/v3',
    environment: 'master'
  },
  authorizationProxy: {
    url: 'https://proxy.digital.telus.com/oauth2'
  }
}
